import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CandidateData {
  id: number;
  cpf: string;
  nomeCompleto: string;
  sexo: 'MASCULINO' | 'FEMININO' | 'OUTRO' | 'NAO_INFORMAR';
  desejaNomeSocial: boolean;
  nomeSocial?: string;
  dataNascimento: string;
  rg: string;
  nomePai?: string;
  profissaoPai?: string;
  nomeMae: string;
  nacionalidade: string;
  estadoCivil: 'SOLTEIRO' | 'CASADO' | 'DIVORCIADO' | 'VIUVO' | 'UNIAO_ESTAVEL' | 'OUTRO' | 'NAO_INFORMAR';
  nivelEscolaridade: 'FUNDAMENTAL' | 'MEDIO' | 'TECNICO' | 'SUPERIOR' | 'POS' | 'MESTRADO' | 'DOUTORADO' | 'OUTRO' | 'NAO_INFORMAR';
  numeroDependentes: number;
  telefonePessoal: string;
  outroTelefone?: string;
  email: string;
  emailAlternativo?: string;
  receberInfoOrganizadora: boolean;
  declaracaoCanaisAtualizados: boolean;
  createdAt?: string;
  updatedAt?: string;
  // Endereço
  cidadeId?: number;
  estadoId?: number;
  cep?: string;
  endereco?: string;
  logradouro?: string;
  numero?: string;
  semNumero?: boolean;
  complemento?: string;
  bairro?: string;
}

export interface CandidateUpdateRequest {
  nomeCompleto: string;
  sexo: 'MASCULINO' | 'FEMININO' | 'OUTRO' | 'NAO_INFORMAR';
  desejaNomeSocial: boolean;
  nomeSocial?: string;
  dataNascimento: string;
  rg: string;
  nomePai?: string;
  profissaoPai?: string;
  nomeMae: string;
  nacionalidade: string;
  estadoCivil: 'SOLTEIRO' | 'CASADO' | 'DIVORCIADO' | 'VIUVO' | 'UNIAO_ESTAVEL' | 'OUTRO' | 'NAO_INFORMAR';
  nivelEscolaridade: 'FUNDAMENTAL' | 'MEDIO' | 'TECNICO' | 'SUPERIOR' | 'POS' | 'MESTRADO' | 'DOUTORADO' | 'OUTRO' | 'NAO_INFORMAR';
  numeroDependentes: number;
  telefonePessoal: string;
  outroTelefone?: string;
  emailAlternativo?: string;
  receberInfoOrganizadora: boolean;
  declaracaoCanaisAtualizados: boolean;
  cidadeId?: number;
  cep?: string;
  logradouro?: string;
  numero?: string;
  semNumero?: boolean;
  complemento?: string;
  bairro?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CandidateService {
  private apiUrl = `${environment.apiUrl}/candidatos`;

  constructor(private http: HttpClient) {}

  /**
   * GET /api/candidatos/me
   * Busca dados do candidato autenticado
   */
  getMe(): Observable<CandidateData> {
    return this.http.get<CandidateData>(`${this.apiUrl}/me`);
  }

  /**
   * PUT /api/candidatos/me
   * Atualiza dados do candidato autenticado
   */
  updateMe(data: CandidateUpdateRequest): Observable<CandidateData> {
    return this.http.put<CandidateData>(`${this.apiUrl}/me`, data);
  }
}
